"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "13",
  cy: "13",
  r: "1",
  opacity: ".3"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.28 13c-.15 0-.28.13-.28.28 0 .12.08.24.2.27l4.51 1.29 2.33-1.4c-.02-.15-.03-.29-.03-.44zm14.48-9.46c-.15-.09-.29-.01-.34.04L14 6.78v3.36l.11.03 3.74-6.24c.09-.14.04-.31-.09-.39m.43 11.94-2.78-.69c-.07.1-.15.19-.24.28l4.85 4.85c.16.16.35.05.4 0 .09-.09.11-.23.05-.33z",
  opacity: ".3"
}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4 3h6v2H4zM1 7h5v2H1zm2 12h5v2H3z"
}, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m22.21 18.61-2.28-4.1c-.27-.48-.73-.83-1.26-.97l-2.69-.67c-.02-.47-.14-.92-.37-1.33l3.96-6.59c.65-1.08.3-2.48-.78-3.13-.36-.22-.77-.32-1.17-.32-.56 0-1.12.21-1.56.62l-3.43 3.21c-.4.37-.63.9-.63 1.45v3.4c-.47.17-.89.45-1.23.82H3.28C2.02 11 1 12.02 1 13.28c0 1.02.67 1.91 1.65 2.19l4.51 1.29c.18.05.37.08.55.08.36 0 .72-.1 1.03-.29l2.24-1.34c.29.26.63.47 1.02.61V21c-1.1 0-2 .9-2 2h6c0-1.1-.9-2-2-2v-4.28l4.61 4.61c.45.45 1.03.67 1.61.67.58 0 1.17-.22 1.61-.67.72-.72.88-1.83.38-2.72M7.72 14.84 3.2 13.55c-.12-.03-.2-.15-.2-.27 0-.15.13-.28.28-.28h6.73c0 .15.01.3.03.44zM13 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m1-3.86V6.78l3.43-3.21c.05-.05.19-.12.34-.04.13.08.18.25.1.38l-3.74 6.24zm6.42 9.78c-.05.05-.24.16-.4 0l-4.85-4.85c.08-.09.16-.18.24-.28l2.78.69 2.28 4.1c.06.11.04.25-.05.34"
}, "3")], 'WindPowerTwoTone');